import { lives } from "@/mocks/lives";
import LiveCard from "@/components/feature/LiveCard";
import SectionHeading from "@/components/base/SectionHeading";

const hotLives = [...lives].sort((a, b) => b.viewers - a.viewers).slice(0, 8);

export default function HotLives() {
  return (
    <section className="w-full bg-background-100 border-y border-background-200/70">
      <div className="w-full px-4 md:px-8 py-10 md:py-14">
        <SectionHeading
          eyebrow="热门推荐"
          icon="ri-fire-line"
          title="此刻最火的直播"
          subtitle="根据实时观看人气精选，跟着大家的选择一起围观最热门的内容。"
          moreTo="/category/game"
          moreLabel="浏览全部直播"
        />
        <div className="grid grid-cols-1 sm:grid-cols-2 lg:grid-cols-4 gap-4 md:gap-5" data-product-shop>
          {hotLives.map((live) => (
            <LiveCard key={live.id} live={live} />
          ))}
        </div>
      </div>
    </section>
  );
}